import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
// import HomePage from "../components/HomePage";
import Login from "../components/auth/Login";
import VerifyOtp from "../components/auth/VerifyOtp";
import Register from "../components/auth/Register";
import AdminLayout from "../components/admin/AdminLayout";
import AdminList from "../components/admin/AdminList";
import DataContext from "../context/DataContext";
import HomePage from "../components/home-page/HomePage";
import MemberDetails from "../components/admin/MemberDetails";
const RouteConfig = () => {
  const { pageLoading } = useContext(DataContext);
  return (
    <div>
      {pageLoading && (
        <div className="loader_div">
          <div className="ring"></div>
          <div className="ring"></div>
          <div className="ring"></div>
        </div>
      )}
      <div>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verfiy" element={<VerifyOtp />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route
              path="/admin"
              element={<Navigate replace to="/admin/list" />}
            />
            <Route path="/admin/list" element={<AdminList />} />
            <Route path="/admin/details/:id" element={<MemberDetails />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
};

export default RouteConfig;
